import Booking from './Booking'
import Clients from './Clients'
import Integrations from './Integrations'
import Premium from './Premium'
import Pricing from './Pricing'
import Profile from './Profile'
import Finance from './Finance'
import Settings from './Settings'
import Statistics from './Statistics'
import Tasks from './Tasks'
import Templates from './Templates'
import Widgets from './Widgets'
import Password from './Password'
import Offer from './Offer'
import Refresh from './Refresh'
import Employees from './Employees'
import Help from './Help'
import OldWidgets from './Widgets/OldWidgets'
import { ILicense, LicenseType } from '../../../../models/License'
import { useSelector } from 'react-redux'
import {
  getActiveLicense,
  isTrialAccount,
} from '../../../../reducers/userAccount/selectors/license'
import { isUserNewPackage } from '../../../../reducers/userAccount/selectors/userAccount'

export enum PlansScope {
  ReservationList,
  Clients,
  MessageTemplates,
  SetPrices,
  PricingConfig,
  Prepayment,
  AdditionalServices,
  Statistics,
  FinancialReport,
  RoomReport,
  OccupancyReport,
  LocalTaxReport,
  PaymentList,
  LodgingBook,
  ReservationExport,
  InvoiceOpen,
  Taxes,
  TaxRates,
  ReservationSystemConfig,
  PaymentMethods,
  Amenities,
  Notifications,
  LicenseNumber,
  Airbnb,
  BookingCom,
  ICalendar,
  Employees,
  Tasks,
  ContactDetails,
}

export const CurrentPlans: Record<string | number, PlansScope[]> = {
  freemium: [
    PlansScope.ReservationList,
    PlansScope.Clients,
    PlansScope.MessageTemplates,
    PlansScope.SetPrices,
    PlansScope.PricingConfig,
    PlansScope.Prepayment,
    PlansScope.AdditionalServices,
    PlansScope.Statistics,
    PlansScope.FinancialReport,
    PlansScope.RoomReport,
    PlansScope.OccupancyReport,
    PlansScope.LocalTaxReport,
    PlansScope.PaymentList,
    PlansScope.LodgingBook,
    PlansScope.ReservationExport,
    PlansScope.InvoiceOpen,
    PlansScope.Taxes,
    PlansScope.TaxRates,
    PlansScope.ReservationSystemConfig,
    PlansScope.PaymentMethods,
    PlansScope.Amenities,
    PlansScope.Notifications,
    PlansScope.LicenseNumber,
    PlansScope.Airbnb,
    PlansScope.BookingCom,
    PlansScope.ICalendar,
    PlansScope.Employees,
  ],
  [LicenseType.LICENSE_PREMIUM_LITE]: [
    PlansScope.Tasks,
    PlansScope.MessageTemplates,
    PlansScope.SetPrices,
    PlansScope.PricingConfig,
    PlansScope.AdditionalServices,
    PlansScope.Statistics,
    PlansScope.FinancialReport,
    PlansScope.RoomReport,
    PlansScope.OccupancyReport,
    PlansScope.LocalTaxReport,
    PlansScope.PaymentList,
    PlansScope.LodgingBook,
    PlansScope.InvoiceOpen,
    PlansScope.Taxes,
    PlansScope.TaxRates,
    PlansScope.ReservationSystemConfig,
    PlansScope.PaymentMethods,
    PlansScope.Amenities,
    PlansScope.Notifications,
    PlansScope.LicenseNumber,
    PlansScope.Airbnb,
    PlansScope.BookingCom,
    PlansScope.ICalendar,
    PlansScope.Employees,
    PlansScope.ContactDetails,
  ],
  [LicenseType.LICENSE_PREMIUM_PLUS]: [
    PlansScope.InvoiceOpen,
    PlansScope.Taxes,
    PlansScope.TaxRates,
    PlansScope.Airbnb,
    PlansScope.BookingCom,
    PlansScope.ICalendar,
    PlansScope.Employees,
  ],
  [LicenseType.LICENSE_PREMIUM_PRO]: [
    PlansScope.InvoiceOpen,
    PlansScope.Taxes,
    PlansScope.TaxRates,
    PlansScope.Employees,
  ],
  [LicenseType.LICENSE_PREMIUM_MAX]: [],
  [LicenseType.LICENSE_WEB_ANDROID]: [],
  [LicenseType.LICENSE_WEB_IOS]: [],
  [LicenseType.LICENSE_WEB_ANDROID_IOS]: [],
  [LicenseType.LICENSE_BOOKING_COM]: [],
  [LicenseType.LICENSE_ICALENDAR]: [],
  [LicenseType.LICENSE_PERMISSIONS]: [],
  [LicenseType.LICENSE_INVOICE]: [],
  [LicenseType.LICENSE_PREMIUM_ROOMS]: [],
  [LicenseType.LICENSE_PREMIUM_BASIC]: [],
  [LicenseType.LICENSE_PREMIUM_ASSISTENT]: [],
  [LicenseType.LICENSE_PREMIUM_PROFESSIONAL]: [],
}

export const mapPlansScopeToLicense = (
  license: ILicense,
  fremium = false,
  isNewPremiumPriceGroup?,
) => {
  return fremium && !isNewPremiumPriceGroup
    ? []
    : license && isNewPremiumPriceGroup
    ? CurrentPlans[license.licenseType]
    : CurrentPlans['freemium']
}

export const useLicensePlansScope = () => {
  const currentPlan = useSelector(getActiveLicense)
  const fremium = useSelector(isTrialAccount)
  const isNewPremiumPriceGroup = useSelector(isUserNewPackage)
  const plansScope = mapPlansScopeToLicense(
    currentPlan,
    fremium,
    isNewPremiumPriceGroup,
  )

  return plansScope
}

export const isInPlanScope = (
  scopes: PlansScope[],
  planScope: PlansScope,
  userPriceGroup?: number,
) => {
  const priceGroup = +userPriceGroup
  const isInScope = scopes.includes(planScope) && priceGroup === 3

  return isInScope
}

export const isInPlanScopeRedirect = (
  scopes: PlansScope[],
  planScope: PlansScope,
  redirect,
  userPriceGroup?: number,
  skipScope?: boolean,
) => {
  const priceGroup = +userPriceGroup
  const isInScope = scopes.includes(planScope) && priceGroup === 3

  if (isInScope && skipScope === false) {
    return isInScope
  }
  return redirect
}
export {
  Booking,
  Premium,
  Clients,
  Integrations,
  Pricing,
  Profile,
  Finance,
  Settings,
  Statistics,
  Tasks,
  Templates,
  Widgets,
  Password,
  Offer,
  Refresh,
  Help,
  Employees,
  OldWidgets,
}
